<template>
  <div ref="DefaultTemp" class="d-none">
    <div v-html="EjsData"></div>
  </div>
</template>

<script>
import Printd from "printd";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import PosService from "@/services/PosService";
import moment from "moment";
import { EventBus } from "@/main";
import { mapState, mapGetters, mapActions } from "vuex";
import { Role, CLIENT_NAME } from "@/helper/Role";

export default {
  props: {
    ticketDetails: {
      type: Array
    }
  },
  data() {
    return {
      EjsData: null
    };
  },
  computed: {
    isReprint() {
      return this.$store.getters.isReprint;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    offerFor() {
      return this.$store.getters.getOfferFor;
    },
    getSelectedOffer() {
      return this.$store.getters.getSelectedOffer;
    },
    offerPrice() {
      return this.getOfferPrice ? parseFloat(this.getOfferPrice).toFixed(2) : 0;
    },
    totalAmount() {
      return this.getOfferPrice > 0
        ? this.$store.getters.TOTAL_AMOUNT - this.getOfferPrice
        : this.$store.getters.TOTAL_AMOUNT;
    },
    netAmount() {
      return this.$store.getters.NET_AMOUNT;
    },
    AdditionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    getcurrency() {
      return this.$store.getters.GET_CURRENCY;
    },
    showBookingId() {
      return this.$store.getters.SHOW_BOOKING_ID;
    },
    getSeats() {
      let key = "seatType";
      if (
        this.$store.getters.BOOKING_DETAILS &&
        this.$store.getters.BOOKING_DETAILS.seats_types &&
        this.$store.getters.BOOKING_DETAILS.seats_types.length > 0
      ) {
        return this.$store.getters.BOOKING_DETAILS.seats_types.reduce(function(
          rv,
          x
        ) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        },
        {});
      }
      // };
      // return groupBy;
      // (groupBy(['one', 'two', 'three'], 'length'))
    },
    getSelectedArray() {
      let array = [];
      if (
        this.bookingDetails &&
        this.bookingDetails["seats_types"] &&
        this.bookingDetails["seats_types"].length > 0
      ) {
        this.bookingDetails.seats_types.map(x => {
          x.seats.map(y => {
            array.push({
              seatName: y,
              seatType: x.seat_type
            });
          });
        });
      }
      return array;
    },
    transactionArr() {
      return this.$store.getters.TRANSACTION_IDARR;
    },
    ...mapGetters([
      "getOfferPrice",
      "getSelectedOffer",
      "getOfferFor",
      "IDforBoxOfficeEjs"
    ])
  },
  beforeMount() {
    EventBus.$on("printDefaultTempEmpire", () => {
      // this.print();
      this.GetEmpireTicket();
    });
  },
  mounted() {
    EventBus.$on("printDefaultTemp", () => {
      // this.print();
      this.GetEjsTicket();
    });
  },
  beforeDestroy() {
    //after called $on event destroy that event to do not call function multiple times
    EventBus.$off("printDefaultTemp");
  },
  methods: {
    GetEmpireTicket() {
      let loader = this.$loading.show();
      let { cinema_id } = this.secureStore.get("USINFO");
      let transactions = this.transactionArr.split(",") || [];
      if (transactions.length > 0) {
        transactions.map(transaction => {
          PosService.GetEmpireTicketEjs(
            transaction,
            cinema_id,
            this.isReprint
          ).then(response => {
            const { data } = response;
            this.EjsData = data;
            this.$nextTick(() => {
              loader.hide();
              this.print();
            });
          });
        });
      }
    },
    calculateTicketPrice(value) {
      return value
        ? parseFloat(parseFloat(value) - parseFloat(this.offerPrice)).toFixed(2)
        : 0;
    },
    GetEjsTicket: function() {
      let loader = this.$loading.show();

      PosService.GetTicketEjs(
        this.IDforBoxOfficeEjs.sb_id,
        this.IDforBoxOfficeEjs.cinema_id,
        this.isReprint
      )
        .then(response => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            this.print();
          });
        })
        .catch(this._CatchError);
      if (true) {
        PosService.GetTicketSecurityEjs(
          this.IDforBoxOfficeEjs.sb_id,
          this.IDforBoxOfficeEjs.cinema_id,
          this.isReprint
        )
          .then(response => {
            const { data } = response;

            // this.EjsData = data;

            this.$nextTick(() => {
              loader.hide();
              // this.print();
            });
          })
          .catch(this._CatchError);
      }
      // .finally(() => {
      //   setTimeout(() => loader.hide(), 1000);
      // });
    },
    print: function() {
      const p = new Printd();
      if (this.$refs.DefaultTemp) {
        p.print(this.$refs.DefaultTemp, []);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/PrintTicketTemplates/Default_Template.vue